import { useState } from "react";
import { toast } from "sonner";
import { REPLY_TEMPLATES, renderReply, buildMailto } from "../lib/replyTemplates";

// Draft state + the three actions (copy / mailto / portal send) for one lead.
export const useReplyDraft = ({ lead, onStatus, onSend, onClose }) => {
  const [templateId, setTemplateId] = useState(REPLY_TEMPLATES[0].id);
  const [note, setNoteState] = useState("");
  const [copied, setCopied] = useState(false);
  const [sending, setSending] = useState(false);

  const template = REPLY_TEMPLATES.find((t) => t.id === templateId);
  const draft = lead ? renderReply(template, lead, note) : { subject: "", body: "" };
  const willChangeStatus = !!lead && !!template.status && lead.status !== template.status && lead.status !== "Closed";

  const pick = (id) => { setTemplateId(id); setCopied(false); };
  const setNote = (v) => { setNoteState(v); setCopied(false); };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(`Subject: ${draft.subject}\n\n${draft.body}`);
      setCopied(true);
      toast.success("Reply copied to clipboard");
    } catch {
      toast.error("Couldn't access clipboard");
    }
  };

  const mailtoHref = lead ? buildMailto(lead, draft.subject, draft.body) : "#";
  const mailto = () => {
    window.location.href = mailtoHref;
    if (willChangeStatus) onStatus(lead.id, template.status);
  };

  const send = async () => {
    setSending(true);
    try {
      await onSend(lead.id, templateId, note);
      toast.success(`Reply sent to ${lead.email}`);
      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reply could not be sent");
    } finally {
      setSending(false);
    }
  };

  return { templateId, template, note, setNote, draft, copied, sending, willChangeStatus, pick, copy, mailto, mailtoHref, send };
};
